import ElectralinkMeterSearch from "../components/electralink/ElectralinkMeterSearch";

const Electralink: React.FC = () => {
  return <ElectralinkMeterSearch />;
};

export default Electralink;
